<template>
  <div id="app">
    <div v-if="$route.meta.keepAlive">
    <FatherView msg="77777"/>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import FatherView from './FatherView.vue'

export default {
  name: 'app',
  components: {
    FatherView
  }
}

</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  width: 80%;
  color: #2c3e50;
  margin-top: 60px;
  margin-left: 100px;
}
</style>
